// Import necessary libraries
import React from 'react';
import { Grid } from '@mui/material';
import Layout from '../../Layout';
import EncountersByFaciltyType from './Components/Graph/EncountersByFaciltyType';
import EncountersByFacility from './Components/Graph/EncountersByFacility';
import EncountersByProvider from './Components/Graph/EncountersByProvider';
import EncountersByCpt from './Components/Graph/EncountersByCpt';
import EncountersByDx from './Components/Graph/EncountersByDx';

const Dashboard = () => {
  return (
    <Layout>
      <Grid container alignItems="stretch">
        <Grid item md={6} xs={12} sx={{ p: 2, display: 'flex' }}>
          <EncountersByFaciltyType style={{ flex: 1, height: '100%' }} />
        </Grid>
        <Grid item md={6} xs={12} sx={{ p: 2, display: 'flex' }}>
          <EncountersByFacility style={{ flex: 1, height: '100%' }} />
        </Grid>
        <Grid item md={6} xs={12} sx={{ p: 2, display: 'flex' }}>
          <EncountersByProvider style={{ flex: 1, height: '100%' }} />
        </Grid>
        <Grid item md={6} xs={12} sx={{ p: 2, display: 'flex' }}>
          <EncountersByCpt style={{ flex: 1, height: '100%' }} />
        </Grid>
        <Grid item md={6} xs={12} sx={{ p: 2, display: 'flex' }}>
          <EncountersByDx style={{ flex: 1, height: '100%' }} />
        </Grid>
      </Grid>
    </Layout>
  );
};

export default Dashboard;
